import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode } from "vue"


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { getAppidList, deleteAppid, resetAppid, updateAppid } from '@/api/marketing/marketingManage'
import vIfAndPermission from '@/utils/ifAndPermission'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { AppidSubmitParams } from '@/typings/api/marketingManage'
const __default__ = { name: 'DcCosZbuAppidMange' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref<{ toggle:(row?: AppidSubmitParams) => void }>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await getAppidList()
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: 'APPID', dataIndex: 'appKey', width: 330 },
  { title: 'APPSECRET', dataIndex: 'appSecret', width: 330 },
  { title: '名称', dataIndex: 'appName' },
  { title: '是否启用', dataIndex: 'status' },
  {
    title: '目标系统',
    dataIndex: 'subdomain',
    dicData: [
      { label: '谷仓', value: 'cos_fbu' },
      { label: '云途', value: 'cos_lbu' }
    ]
  },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '操作时间', dataIndex: 'createTime', width: 200 },

  {
    title: '操作',
    dataIndex: 'action',
    width: 200,
    fixed: 'right'
  }
])
const addEdit = (_row?: AppidSubmitParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: AppidSubmitParams) => {
  Modal.delete({
    name: row.appName,
    onOk() {
      deleteAppid({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
const ResetRow = (row: AppidSubmitParams) => {
  DcConfirm.warning({
    title: '重置提示！',
    content: '是否重置：' + row.appName,
    cancelText: '取消',
    okText: '继续',
    onOk() {
      resetAppid({ id: row.id }).then(() => {
        DcMessage.success('重置成功')
        success()
      })
    }
  })
}
const openAndStopRow = (row: AppidSubmitParams, type: number) => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      updateAppid({ id: row.id, status: type }).then(() => {
        DcMessage.success('操作成功')
        success()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            needPage: false,
            tableId: "DcCosAppidManage"
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (record.status === 1)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("停用")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("启用")
                          ]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'sys_appidmange_edit_btn']
                      ]),
                      (_unref(vIfAndPermission)('sys_appidmange_closeopen_btn', !record.status))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            onClick: ($event: any) => (openAndStopRow(record, 1))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("禁用")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(vIfAndPermission)('sys_appidmange_closeopen_btn', record.status))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "link",
                            onClick: ($event: any) => (openAndStopRow(record, 0))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("启用")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (ResetRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置APPSECRET")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'sys_appidmange_reset_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'sys_appidmange_delete_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'sys_appidmange_add_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})